import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "program-img-wrapper" }
const _hoisted_2 = ["src", "onError"]
const _hoisted_3 = { class: "add-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.openMenu }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.menuOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Тренировки", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_segment, {
            value: _ctx.selectedListSegment,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.listSegmentChange($event))),
            mode: "md",
            class: "custom-segment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment_button, { value: "all" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Все", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_segment_button, { value: "favourites" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Избранное", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _withDirectives(_createVNode(_component_ion_content, { class: "bg-transparent programs-content" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_accordion_group, { value: _ctx.selectedProgram }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                    return (_openBlock(), _createElementBlock("div", { key: programIdx }, [
                      _createVNode(_component_ion_accordion, {
                        class: "bg-transparent",
                        value: program.programName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "program-item",
                            lines: "none",
                            color: "violet"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("img", {
                                  src: _ctx.programLogos[program.shortName] || _ctx.getProgramImage(program.shortName),
                                  alt: "program logo",
                                  onError: ($event: any) => (_ctx.onProgramLogoError(program.shortName))
                                }, null, 40, _hoisted_2)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.globalContext.isManager && !_ctx.globalContext.offlineMode)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 0,
                                    color: "violet",
                                    class: "release-item release-add-item",
                                    onClick: ($event: any) => (_ctx.openNewReleaseForm(program))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode("+", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(program.fullReleases, (release) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: release.id,
                                  name: "itemSliding-all"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      color: "violet",
                                      class: "release-item",
                                      detail: true,
                                      onClick: ($event: any) => (_ctx.openRelease(program, release))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(program.programName + " " + release.releaseName), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_ion_item_options, {
                                      side: "end",
                                      onIonSwipe: ($event: any) => (_ctx.addToFavourites(program, release, _ctx.isFavourite(program, release) ? false : true))
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.globalContext.isManager)
                                          ? (_openBlock(), _createBlock(_component_ion_item_option, {
                                              key: 0,
                                              color: "danger",
                                              onClick: ($event: any) => (_ctx.removeRelease(release, program))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.addToFavourites(program, release, true)),
                                          color: "success",
                                          expandable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, !_ctx.isFavourite(program, release)]
                                        ]),
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.addToFavourites(program, release, false)),
                                          color: "success",
                                          class: "white-icon",
                                          expandable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, _ctx.isFavourite(program, release)]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onIonSwipe"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"]),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.selectedListSegment == 'all']
          ]),
          _withDirectives(_createVNode(_component_ion_content, { class: "bg-transparent programs-content programs-content-favourites" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                return (_openBlock(), _createElementBlock("div", { key: programIdx }, [
                  _createVNode(_component_ion_list, {
                    slot: "content",
                    class: "bg-transparent",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(program.fullReleases, (release) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: release.id
                        }, [
                          _withDirectives(_createVNode(_component_ion_item_sliding, { name: "itemSliding-favourites" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                class: "release-item release-favourite-item",
                                color: "violet",
                                detail: true,
                                onClick: ($event: any) => (_ctx.openRelease(program, release))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(program.programName + " " + release.releaseName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_ion_item_options, {
                                side: "end",
                                onIonSwipe: ($event: any) => (_ctx.addToFavourites(program, release, _ctx.isFavourite(program, release) ? false : true))
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_ion_item_option, {
                                    onClick: ($event: any) => (_ctx.addToFavourites(program, release, true)),
                                    color: "success",
                                    expandable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]), [
                                    [_vShow, !_ctx.isFavourite(program, release)]
                                  ]),
                                  _withDirectives(_createVNode(_component_ion_item_option, {
                                    onClick: ($event: any) => (_ctx.addToFavourites(program, release, false)),
                                    color: "success",
                                    class: "white-icon",
                                    expandable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]), [
                                    [_vShow, _ctx.isFavourite(program, release)]
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onIonSwipe"])
                            ]),
                            _: 2
                          }, 1536), [
                            [_vShow, _ctx.isFavourite(program, release)]
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128)),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.selectedListSegment == 'favourites']
          ]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showNewReleaseForm,
            breakpoints: [0, 0.5],
            initialBreakpoint: 0.5,
            onDidDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeNewReleaseForm()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, { class: "new-release-form" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Новый релиз", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeNewReleaseForm())),
                            slot: "end",
                            class: "new-release-form-header-button"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.closeOutline,
                                slot: "icon-only"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, { class: "new-release-form" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-center new-release-form-program" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.newReleaseProgram[0].programName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Номер релиза",
                        "label-placement": "floating",
                        fill: "solid",
                        type: "text",
                        placeholder: "Номер релиза",
                        modelValue: _ctx.newReleaseName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newReleaseName) = $event)),
                        autocomplete: "off",
                        autocorrect: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveNewRelease(_ctx.newReleaseProgram[0])))
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.add
                        }, null, 8, ["icon"]), [
                          [_vShow, !_ctx.newReleaseCreating]
                        ]),
                        _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                          [_vShow, _ctx.newReleaseCreating]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}